/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * 
 * @export
 */
export const TaskStatusType = {
    Open: 'Open',
    Closed: 'Closed'
} as const;
export type TaskStatusType = typeof TaskStatusType[keyof typeof TaskStatusType];


export function TaskStatusTypeFromJSON(json: any): TaskStatusType {
    return TaskStatusTypeFromJSONTyped(json, false);
}

export function TaskStatusTypeFromJSONTyped(json: any, ignoreDiscriminator: boolean): TaskStatusType {
    return json as TaskStatusType;
}

export function TaskStatusTypeToJSON(value?: TaskStatusType | null): any {
    return value as any;
}

